import { defineMessages } from 'react-intl';

const messages = defineMessages({
  vendorSettings: {
    defaultMessage: 'Edit Settings',
    id: 'XdzN/7',
    description: 'Vendor Settings dropdown label',
  },
  resendEmailInvite: {
    defaultMessage: 'Resend Email Invite',
    id: 'jED5Gn',
    description: 'Resend Email dropdown label',
  },
  cancelEmailInvite: {
    defaultMessage: 'Cancel Email Invite',
    id: 'uwDJcO',
    description: 'Cancel Pending Invite dropdown label',
  },
  deactivateVendor: {
    defaultMessage: 'Deactivate Vendor',
    id: 'LqB6Ql',
    description: 'Deactivate vendor dropdown label',
  },
  carrierSharing: {
    defaultMessage: 'Carrier Sharing',
    id: 'ghvmTW',
    description: 'Carrier Sharing dropdown label',
  },
});

export default messages;
